<template>
  <base-section
    id="loan-estimate"
    class="text-center"
  >
    <div />
    <v-container>
      <v-row
        justify="center"
      >
        <v-col
          cols="12"
          md="12"
        >
          <base-info-card
            :title="title"
            :subtitle="subTitle"
            space="4"
            color="primary"
          />
        </v-col>
        <!-- <v-col
          cols="12"
          md="3"
        >
          <base-info-card
            subtitle="Heq Options"
            space="4"
            color="primary"
          />
          <v-row
            justify="center"
          >
            <v-col
              cols="12"
              md="6"
            >
              <p class="mr-4 ml-4">
                Select the number of years you would like to skip a payment
              </p>
            </v-col>
            <v-col
              cols="12"
              md="1"
            >
              <v-form class="mt-0">
                <v-slider
                  v-model="loanConfiguration.deferredYears"
                  :tick-labels="deferredYearsLabels"
                  :max="5"
                  :min="0"
                  ticks="always"
                  tick-size="5"
                  vertical
                />
              </v-form>
            </v-col> -->
        <!-- </v-row>
        </v-col> -->
        <v-col
          cols="12"
          md="6"
        >
          <div>
            <v-row
              justify="center"
            >
              <v-col
                cols="12"
                md="11"
              >
                <!-- v-autocomplete -->
                <v-text-field
                  v-model="loanConfiguration.loanAmountBase"
                  v-money="money"
                  :error-messages="loanAmountBaseErrors"
                  label="Desired Loan Amount"
                  required
                  @keydown.enter.prevent="debounceInput"
                />
              </v-col>
            </v-row>
            <v-row
              justify="center"
              class="mb-n10"
            >
              <v-col
                cols="12"
                md="5"
              >
                <v-card
                  flat
                  :disabled="monthlyPaymentSelected"
                >
                  <p>Calculate using the loan term</p>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                md="1"
                class="mt-n4"
              >
                <v-switch v-model="monthlyPaymentSelected" />
              </v-col>
              <v-col
                cols="12"
                md="5"
              >
                <v-card
                  flat
                  :disabled="!monthlyPaymentSelected"
                >
                  <p>Calculate using monthly payment</p>
                </v-card>
              </v-col>
            </v-row>
            <v-form>
              <v-row
                justify="center"
                class="mt-n8"
              >
                <v-col
                  cols="12"
                  md="5"
                >
                  <v-autocomplete
                    v-model="loanConfiguration.term"
                    auto-select-first
                    :items="termYearsLabels"
                    label="Term (years)"
                    :disabled="monthlyPaymentSelected"
                    outlined
                    required
                    @keydown.enter.prevent="debounceInput"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="1"
                >
                  <!-- <v-switch v-model="monthlyPaymentSelected" /> -->
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                >
                  <v-text-field
                    v-model="loanConfiguration.monthlyPayment"
                    v-money="money"
                    label="Monthly Payment"
                    :disabled="!monthlyPaymentSelected"
                    append-icon="mdi-currency-usd"
                    outlined
                    required
                    @keydown.enter.prevent="debounceInput"
                  />
                </v-col>
              </v-row>
            </v-form>
          </div>
          <v-row
            justify="center"
          >
            <base-btn
              @click="debounceInput"
            >
              Calculate
            </base-btn>
          </v-row>
        </v-col>
        <!-- <v-col
          cols="12"
          md="3"
        >
          <base-info-card
            subtitle="Other Options"
            space="4"
            color="primary"
          />
          <v-form style="padding: 10px;">
            <v-text-field
              v-model="loanConfiguration.otherRate"
              :error-messages="loanAmountBaseErrors"
              label="Other Guy's Rate"
              append-icon="mdi-percent-outline"
              required
              @keydown.enter.prevent="debounceInput"
            />
          </v-form>
        </v-col> -->
      </v-row>
      <v-row
        justify="center"
      >
        <v-col
          cols="12"
          md="2"
        >
          <base-info-card
            title="Heq Options"
            space="4"
            color="primary"
          />
          <v-row
            justify="center"
          >
            <p class="mr-4 ml-4">
              Select the number of years you would like to skip a payment
            </p>
          </v-row>
          <v-row
            justify="center"
          >
            <v-form class="mt-0">
              <!-- <v-slider
                v-model="loanConfiguration.deferredYears"
                :tick-labels="deferredYearsLabels"
                :max="5"
                :min="0"
                ticks="always"
                tick-size="5"
                vertical
              /> -->
              <circle-slider
                v-model="loanConfiguration.deferredYears"
                progress-color="#42a5f6"
                knob-color="#42a5f6"
                :side="150"
                :min="0"
                :max="5"
                :step-size="1"
                :circle-width-rel="20"
                :progress-width-rel="10"
                :knob-radius="10"
              />
            </v-form>
          </v-row>
          <v-row
            justify="center"
          >
            <v-col
              cols="12"
              md="4"
            >
              <p><strong>{{ loanConfiguration.deferredYears }} year(s)</strong></p>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <price-card v-bind="heqPlan" />
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <price-card v-bind="otherPlan" />
        </v-col>

        <v-col
          cols="12"
          md="2"
        >
          <v-row justify="center">
            <base-info-card
              title="Other Guy's Options"
              space="4"
              color="primary"
            />
          </v-row>
          <v-row
            justify="center"
          >
            <p class="mr-4 ml-4">
              Select the Other Guy's interest rate
            </p>
          </v-row>
          <v-row justify="center">
            <v-form
              class="mt-0"
              disabled
            >
              <circle-slider
                v-model="loanConfiguration.otherRate"
                disabled
                progress-color="#cf142b"
                knob-color="#cf142b"
                :side="150"
                :min="2"
                :max="5"
                :step-size="0.05"
                :circle-width-rel="20"
                :progress-width-rel="10"
                :knob-radius="10"
              />
            </v-form>
          </v-row>
          <v-row
            justify="center"
          >
            <v-col
              cols="12"
              md="4"
            >
              <p><strong>{{ otherRateFixed }}%</strong></p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import Finance from 'financejs'
  import _ from 'lodash'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'SectionLoanComparison',
    components: {
      PriceCard: () => import('@/components/LoanComparisonCard'),
    },

    mixins: [validationMixin],
    validations: {
      loanConfiguration: {
        loanAmountBase: { required },
      },
    },
    provide: {
      heading: { align: 'center' },
    },
    data: () => ({
      money: {
        prefix: '$ ',
        precision: 0,
      },
      monthlyPaymentSelected: false,
      title: 'Compare',
      subTitle: 'Find out if the HEQ loan is right for you',
      loanConfiguration: {
        term: 30,
        monthlyPayment: 0,
        otherTerm: 30,
        deferredYears: 5,
        rate: 2,
        otherRate: 3.75,
        otherMonthlyPayment: 0,
        loanAmountBase: 0,
      },
      otherDefferedYears: 0,
      deferredYearsLabels: ['0', '1', '2', '3', '4', '5'],
      termYearsLabels: ['10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      internalPlans: [
        {
          title: 'HEQ Loan',
          subtitle: 'HEQ - Flexible, Stable and Secure',
          value: true,
          link: true,
          totalPaid: 0,
          totalSkippedSavings: 0,
          monthlyPayment: 0,
          totalSavings: 0,
          actualLoanAmount: 0,
          termMonths: 0,
          features: [
            '2% Fixed Rate',
            'Monthly Payment: $',
            'No payment for up to 5 years',
            '30 Year Loan',
          ],
        },
        {
          title: 'The Other Guys',
          subtitle: 'Square peg in a round hole',
          value: false,
          link: false,
          totalPaid: 0,
          totalSkippedSavings: 0,
          monthlyPayment: 0,
          totalSavings: 0,
          actualLoanAmount: 0,
          termMonths: 0,
          features: [
            'Market Rate Fixed 3.75%',
            'Monthly Payment: $',
            'Don\'t even think about skipping a payment',
            '30 Year Loan',
          ],
        },
      ],
      interval: 0,
    }),

    computed: {
      loanAmountBase () {
        return this.convertCurrencyToInt(this.loanConfiguration.loanAmountBase)
      },
      otherRateFixed () {
        return this.loanConfiguration.otherRate.toFixed(2)
      },
      plans () {
        return this.internalPlans.map(plan => {
          return {
            ...plan,
            features: plan.features,
            title: plan.title,
            subtitle: plan.subtitle,
            totalSavings: plan.totalSavings,
          }
        })
      },
      heqPlan () {
        return {
          title: 'HEQ Loan',
          subtitle: 'HEQ - Flexible, Stable and Secure',
          value: true,
          link: true,
          totalPaid: this.internalPlans[0].totalPaid,
          totalSkippedSavings: this.internalPlans[0].totalSkippedSavings,
          monthlyPayment: this.internalPlans[0].monthlyPayment,
          totalSavings: this.internalPlans[0].totalSavings,
          actualLoanAmount: this.internalPlans[0].actualLoanAmount,
          termMonths: this.internalPlans[0].termMonths,
          features: [
            `$${this.numberWithCommas(Number(this.internalPlans[1].totalPaid - this.internalPlans[0].totalPaid).toFixed(0))} Cash Savings`,
            `$${this.numberWithCommas(this.internalPlans[0].totalSkippedSavings)} Skipped Payment Savings`,
            '2.00% Fixed Rate',
            `Actual Loan Amount: $${this.numberWithCommas(this.internalPlans[0].actualLoanAmount)}`,
            `${Number(this.internalPlans[0].termMonths / 12).toFixed(0)} Year, ${Number(this.internalPlans[0].termMonths % 12).toFixed(0)} Month Loan`,
            // `${Number(this.loanConfiguration.term).toFixed(0)} Year Loan`,
            `No payment for ${this.loanConfiguration.deferredYears} year(s)`,
            `$${this.numberWithCommas(this.internalPlans[0].monthlyPayment)} Monthly Payment`,
            `$${this.numberWithCommas(Number(this.internalPlans[0].totalPaid).toFixed(0))} Total Paid`,
          ],
        }
      },
      otherPlan () {
        return {
          title: 'The Other Guys',
          subtitle: 'Square peg in a round hole',
          value: false,
          link: false,
          totalPaid: this.internalPlans[1].totalPaid,
          totalSkippedSavings: this.internalPlans[1].totalSkippedSavings,
          monthlyPayment: this.internalPlans[1].monthlyPayment,
          totalSavings: this.internalPlans[1].totalSavings,
          actualLoanAmount: this.internalPlans[1].actualLoanAmount,
          termMonths: this.internalPlans[1].termMonths,
          features: [
            '$0 Cash Savings',
            '$0 Skipped Payment Savings',
            `${this.otherRateFixed}% Fixed Rate`,
            `Actual Loan Amount: $${this.numberWithCommas(this.internalPlans[1].actualLoanAmount)}`,
            `${Number(this.internalPlans[1].termMonths / 12).toFixed(0)} Year, ${Number(this.internalPlans[1].termMonths % 12).toFixed(0)} Month Loan`,
            // `${Number(this.loanConfiguration.otherTerm).toFixed(0)} Year Loan`,
            'Don\'t even think about skipping a payment',
            `$${this.numberWithCommas(this.internalPlans[1].monthlyPayment)} Monthly Payment`,
            `$${this.numberWithCommas(Number(this.internalPlans[1].totalPaid).toFixed(0))} Total Paid`,
          ],
        }
      },
      loanAmountBaseErrors () {
        const errors = []
        if (!this.$v.loanConfiguration.loanAmountBase.$dirty) return errors
        !this.$v.loanConfiguration.loanAmountBase.required && errors.push('Loan Amount Base is required.')
        return errors
      },
    },
    beforeMount () {
      this.calculateAll()
    },

    methods: {
      calculateAll () {
        this.calculateTheOtherGuys()
        this.calculateHeqPlus()
      },
      calculateTheOtherGuys () {
        const finance = new Finance.Finance()
        let monthlyPayment, termMonths
        if (this.monthlyPaymentSelected) {
          const desiredMonthlyPayment = this.convertCurrencyToInt(this.loanConfiguration.monthlyPayment)
          // term = Number(this.loanAmountBase / (monthlyPayment * 12)).toFixed(1) // needs to change...
          const [newMonthlyPayment, newTermMonths] = this.calculateOtherUsingMonthlyPayment(desiredMonthlyPayment)
          monthlyPayment = newMonthlyPayment
          termMonths = newTermMonths
        } else {
          monthlyPayment = Math.round(finance.AM(this.loanAmountBase, this.loanConfiguration.otherRate, parseInt(this.loanConfiguration.term), 0))
          termMonths = parseInt(this.loanConfiguration.term * 12)
        }
        this.internalPlans[1].monthlyPayment = monthlyPayment
        this.loanConfiguration.otherMonthlyPayment = monthlyPayment
        this.internalPlans[1].totalPaid = monthlyPayment * termMonths
        this.internalPlans[1].actualLoanAmount = this.loanAmountBase
        // this.loanConfiguration.otherTerm = termMonths / 12
        this.internalPlans[1].termMonths = termMonths
      },

      calculateOtherUsingMonthlyPayment (desiredMonthlyPayment) {
        // const finance = new Finance.Finance()
        const months = this.calculateMonths(this.loanAmountBase, this.loanConfiguration.otherRate, desiredMonthlyPayment)
        return [desiredMonthlyPayment, months]
        // for (let i = 10; i < 31; i++) {
        //   tmpMonthlyPayment = Math.round(finance.AM(this.loanAmountBase, this.loanConfiguration.otherRate, i, 0))
        //   if (tmpMonthlyPayment < desiredMonthlyPayment) {
        //     return [tmpMonthlyPayment, i]
        //   }
        // }
        // return [tmpMonthlyPayment, 30]
      },

      calculateHeqPlus () {
        const finance = new Finance.Finance()
        const prePaidInterest = this.loanAmountBase * (this.loanConfiguration.deferredYears * 2 / 100)
        const loanAmount = prePaidInterest + parseInt(this.loanAmountBase)
        let monthlyPayment, termMonths

        if (this.monthlyPaymentSelected) {
          const desiredMonthlyPayment = this.convertCurrencyToInt(this.loanConfiguration.monthlyPayment)
          const [newMonthlyPayment, newTermMonths] = this.calculateHeqUsingMonthlyPayment(desiredMonthlyPayment, loanAmount)
          monthlyPayment = newMonthlyPayment
          termMonths = newTermMonths
        } else {
          termMonths = parseInt(this.loanConfiguration.term * 12) - (this.loanConfiguration.deferredYears * 12)
          monthlyPayment = Math.round(finance.AM(loanAmount, this.loanConfiguration.rate, termMonths, 1))
        }
        // const deferralSavings = monthlyPayment * this.loanConfiguration.deferredYears * 12 // should this be calculated with the Other Guy's monthly payment instead?... it's what they would be paying otherwise.

        this.internalPlans[0].totalPaid = monthlyPayment * termMonths
        const deferralSavings = this.internalPlans[1].monthlyPayment * (this.loanConfiguration.deferredYears * 12)
        this.internalPlans[0].totalSavings = Math.round((this.internalPlans[1].totalPaid - this.internalPlans[0].totalPaid) + deferralSavings) // must be after .totalPaid
        this.internalPlans[0].monthlyPayment = monthlyPayment
        this.internalPlans[0].actualLoanAmount = loanAmount
        this.internalPlans[0].totalSkippedSavings = this.internalPlans[1].monthlyPayment * 12 * this.loanConfiguration.deferredYears
        // this.loanConfiguration.term = term + (this.loanConfiguration.deferredYears * 12)
        this.internalPlans[0].termMonths = termMonths + (this.loanConfiguration.deferredYears * 12)
      },

      calculateHeqUsingMonthlyPayment (desiredMonthlyPayment, loanAmount) {
        // const finance = new Finance.Finance()
        // let tmpMonthlyPayment
        // for (let i = 10; i < 31; i++) {
        //   tmpMonthlyPayment = Math.round(finance.AM(loanAmount, this.loanConfiguration.rate, i, 0))
        //   if (tmpMonthlyPayment < desiredMonthlyPayment) {
        //     return [tmpMonthlyPayment, i]
        //   }
        // }
        // return [tmpMonthlyPayment, 30]
        const months = this.calculateMonths(loanAmount, this.loanConfiguration.rate, desiredMonthlyPayment)
        return [desiredMonthlyPayment, months]
      },

      convertCurrencyToInt (val) {
        const type = typeof val
        if (type === 'string') {
          return parseInt(val.replace(/\$/g, '').replace(/ /g, '').replace(/,/g, ''))
        } else if (type === 'number') {
          return val
        } else {
          return 0
        }
      },
      calculateMonths (finAmount, finInterest, finPayment) {
        var result = 0

        if (finInterest === 0) {
          result = Math.ceil(finAmount / finPayment)
        } else {
          result = Math.round(((-1 / 12) * (Math.log(1 - (finAmount / finPayment) * ((finInterest / 100) / 12))) / Math.log(1 + ((finInterest / 100) / 12))) * 12)
        }
        if (!isNaN(result)) {
          return result
        } else {
          return 0
        }
      },
      numberWithCommas (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },

      debounceInput: _.debounce(function () {
        this.$v.loanConfiguration.loanAmountBase.$touch()
        this.calculateAll()
      }, 1000),

    },
  }
</script>
